/* eslint-disable no-unused-vars */

export enum OrderStatus {
    Pending = 'pending',
    Completed = 'completed',
    Cancelled = 'cancelled',
}